/**
 * GraphQL queries for verification operations
 */

/**
 * Send forgot password SMS mutation
 */
export const SEND_FORGOT_PASSWORD_SMS = `
  mutation SendForgotPasswordSms($phoneNumber: String!) {
    sendForgotPasswordSms(phoneNumber: $phoneNumber)
  }
`;

/**
 * Verify forgot password code mutation
 */
export const VERIFY_FORGOT_PASSWORD_CODE = `
  mutation VerifyForgotPasswordCode($phoneNumber: String!, $code: String!, $newPassword: String!) {
    verifyForgotPasswordCode(phoneNumber: $phoneNumber, code: $code, newPassword: $newPassword)
  }
`;

/**
 * Send SMS verification mutation
 */
export const SEND_SMS_VERIFICATION = `
  mutation SendSmsVerification($phoneNumber: String!, $userId: String!) {
    sendSmsVerification(phoneNumber: $phoneNumber, userId: $userId)
  }
`;

export const GET_USER_BY_PHONE = `
  query GetUserByPhone($phoneNumber: String!) {
    getUserByPhone(phoneNumber: $phoneNumber) {
      id
    }
  }
`;

/**
 * Verify SMS code mutation
 */
export const VERIFY_SMS_CODE = `
  mutation VerifySmsCode(
    $phoneNumber: String!, 
    $code: String!, 
    $userId: String!, 
    $marketingConsent: Boolean, 
    $weeklyTipsSubscribed: Boolean
  ) {
    verifySmsCode(
      phoneNumber: $phoneNumber, 
      code: $code, 
      userId: $userId, 
      marketingConsent: $marketingConsent, 
      weeklyTipsSubscribed: $weeklyTipsSubscribed
    )
  }
`;

/**
 * Send email verification mutation
 */
export const SEND_EMAIL_VERIFICATION = `
  mutation SendEmailVerification($email: String!, $userId: String!) {
    sendEmailVerification(email: $email, userId: $userId)
  }
`;

/**
 * Verify email token mutation
 */
export const VERIFY_EMAIL_TOKEN = `
  mutation VerifyEmailToken($token: String!) {
    verifyEmailToken(token: $token)
  }
`;

/**
 * Send 6-digit OTP to email (used for +1 US/Canada registrations)
 */
export const SEND_EMAIL_OTP = `
  mutation SendEmailOtp($email: String!, $userId: String!) {
    sendEmailOtp(email: $email, userId: $userId)
  }
`;

/**
 * Verify 6-digit email OTP (used for +1 US/Canada registrations)
 */
export const VERIFY_EMAIL_OTP = `
  mutation VerifyEmailOtp(
    $userId: String!,
    $email: String!,
    $code: String!,
    $marketingConsent: Boolean,
    $weeklyTipsSubscribed: Boolean
  ) {
    verifyEmailOtp(
      userId: $userId,
      email: $email,
      code: $code,
      marketingConsent: $marketingConsent,
      weeklyTipsSubscribed: $weeklyTipsSubscribed
    ) {
      success
      message
    }
  }
`;
